import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-future-of-bsc-data-science',
  templateUrl: './future-of-bsc-data-science.component.html',
  styleUrls: ['./future-of-bsc-data-science.component.scss']
})
export class FutureOfBScDataScienceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
